import { authApi } from '@api/auth/auth.api';

export const {
  useLoginMutation,
  useLazySsoQuery,
  useCallbackMutation,
  useResetPasswordMutation,
  useNewPasswordMutation,
  useLoginMfaMutation,
  useVerifyUserMutation,
  useResendVerifyMutation,
} = authApi;
